<template>
  <div class="map-selector">
    <app-sel
      v-model="url"
      filterable
      :items="mapProviders"
      key-name="value"
      label-name="key"
      is-object
      class="text-input user-sel"
      @input="$emit('input', url.value)"
    >
      <template v-slot="{ items }">
        <app-sel-opt v-for="item in items" :value="item" :key="item.key">
          {{ item.key }}
        </app-sel-opt>
      </template>
    </app-sel>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
  },
  data() {
    return {
      mapProviders: [
        {
          key: 'Google',
          value: 'https://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
        },
        {
          key: 'Arcgisonline',
          value: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
        },
        {
          key: 'High contrast',
          value: 'https://dev.{s}.tile.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
        },
        // {
        //   key: 'OpenMapTiles',
        //   value: 'https://api.maptiler.com/tiles/satellite/{z}/{x}/{y}.jpg?key=JrbjgXGlAc9iojx2KEDl'
        // },
        // {
        //   key: 'Акварель',
        //   value: 'https://stamen-tiles-b.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png'
        // },
        // {
        //   key: 'Nasa',
        //   value: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/VIIRS_CityLights_2012/default//GoogleMapsCompatible_Level8/{z}/{y}/{x}.jpg'
        // },
      ],
      url: null,
    }
  },
  created() {
    this.url = this.mapProviders[0];
  }
}
</script>

<style lang="scss" scoped>
.map-selector {
  position: absolute;
  z-index: 401;
  background-color: #fff;
  bottom: 10px;
  left: 10px;
  border-radius: 5px;
}
</style>
